export default __webpack_public_path__ + "static/media/regulatory--no-bicycles-mopeds-or-motorcycles--g2.47379579.png";